module.exports = __webpack_public_path__ + "static/media/test17_3.17c5a2cc.png";